"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonyBenefit_1 = require("@/common/colonies/ColonyBenefit");
exports.default = (0, vue_1.defineComponent)({
    name: 'BuildBenefit',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        idx: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ColonyBenefit() {
            return ColonyBenefit_1.ColonyBenefit;
        },
        buildQuantityText() {
            return this.metadata.build.quantity[this.idx] > 1 ? String(this.metadata.build.quantity[this.idx]) : '';
        },
        resource() {
            return (this.metadata.build.resource ?? this.metadata.cardResource)?.toLowerCase();
        },
    },
});
